.cover {
  position: relative;
  aspect-ratio: 16 / 9;

  &:hover + [data-card-actions] {
    display: initial;
  }

  &:hover > [data-card-actions] {
    display: initial;
  }

  &:hover [data-card-actions] {
    display: initial;
  }
}

.project-container {
  width: 100%;
  cursor: pointer;
  opacity: 1;
  transition: opacity 0.2s ease;

  &:hover .cover-collaborators {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.3s ease-in-out;
  }

  &:hover .project-menu {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.3s ease-in-out;
  }

  &[data-archived='true'] {
    opacity: 0.6;
  }
}

.project-title {
  font-size: 1.6rem;
  font-weight: bold;
  letter-spacing: -1px;
  line-height: 1.6rem;
  padding-bottom: 0.8rem;
  text-align: center;
  color: var(--header-project-color);
  overflow: hidden;
  text-overflow: ellipsis;
}

.infos {
  padding-top: 1.2rem;
}

.info {
  color: #5f6164;
  font-size: 1.3rem;
  padding-bottom: 0.2rem;
  text-align: center;
}

.bottom {
  position: absolute;
  visibility: hidden;
  opacity: 0;
  bottom: 0.8rem;
  right: 0.8rem;
}

.project-menu-wrapper {
  position: absolute;
  visibility: hidden;
  opacity: 0;
  top: 0.8rem;
  right: 0.8rem;
}

/* Was `styled(Info)`, so call sites apply .info alongside this. */
.archived-info {
  color: #ffa500;
  font-style: italic;
}
